<template>
    <div class="career-item"  @click="GTMProdCatClick(name)">
        <router-link class="career-item-inner" :to="{ name:'CareerDetails_' + currentLangName(), params: {career_slug: slug}}" >
            <img v-if="src!='no-image'"              
                :alt="name" 
                :title="name" 
                class="img-fluid career-item__img"                                  
                :src="src_url + '/' + src" 
            />
            <img v-else 
                src='@/assets/images/noimage/karrier-no-image.svg' 
                :alt="name" 
                :title="name" 
                class="img-fluid career-item__img"
                />
            <div class="name">{{name}}</div>
            <div class="btn btn--green-border"><span>{{ lang('carrier_megnezem_gomb') }}</span></div>          
        </router-link>
    </div>
</template>

<script>

export default {
    props: ['id', 'name', 'slug', 'src'],
    data(){
        return {
            src_url: process.env.VUE_APP_BIFROST_API_URL_NO_PROJECTNAME
        }
    },
    methods:{
        GTMProdCatClick(name){          
            this.setDataLayer('job_details', name, '')                  
        }
    }
}
</script>